import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { useAppSelector } from "../../Redux/app/hooks";
import { buySellAmount, formatNumber } from "../../helpers/helper";

function EQBOrderConfirmationDetail({ conValue, confirm, ask_value }: any) {
  const form = useAppSelector((state) => state.orderSection.form_data);
  return (
    <>
      <div className="order-confirmation-table">
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>Transaction</th>
              <th>Type</th>
              <th>Duration</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Est. Total</th>
            </tr>
          </thead>
          <tbody>
            <tr className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
              <td>
                <span>{confirm.security_name}</span>
                <div className="tooltiptext">
                  <p>{confirm.security_name}</p>
                </div>
              </td>
              <td>{form.direction.toUpperCase()}</td>
              <td>{form.order_type.toUpperCase()}</td>
              <td>
                <span>{confirm.time.replace(/_/g, " ")}</span>
              </td>
              <td>
                <>
                  {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "buy" ? (
                    <b>N/A</b>
                  ) : (
                    <>{form.direction.toLowerCase() === "buy" && <b>{Number(confirm.price).toFixed(2)}</b>}</>
                  )}
                </>
              </td>
              <td>
                {!conValue ? (
                  <b>{formatNumber(confirm.quantity)}</b>
                ) : (
                  <b>
                    {formatNumber(confirm.quantity)} (Lot size 1 = {new Intl.NumberFormat().format(conValue?.Multiplier)})
                  </b>
                )}
              </td>
              <td className="w-[200px]">
                {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "buy" ? (
                  <b>N/A</b>
                ) : (
                  <>
                    {!conValue ? (
                      <>
                        {form.direction.toLowerCase() === "buy" && (
                          <b>
                            {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} {confirm.currency}
                          </b>
                        )}
                      </>
                    ) : (
                      <>
                        {form.direction.toLowerCase() === "buy" && (
                          <b>
                            {new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)} {confirm.currency}
                          </b>
                        )}
                      </>
                    )}
                  </>
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <>
          {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "buy" ? (
            <></>
          ) : (
            <>
              {!conValue ? (
                <>
                  {form.direction.toLowerCase() === "buy" && (
                    <p>
                      At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                      {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} {confirm.currency}
                    </p>
                  )}
                </>
              ) : (
                <>
                  {form.direction.toLowerCase() === "buy" && (
                    <p>
                      At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                      {new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)} {confirm.currency}
                    </p>
                  )}
                </>
              )}
            </>
          )}
        </>
      </div>
    </>
  );
}

export default EQBOrderConfirmationDetail;
